import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 4.5h12s1.5 0 1.5 1.5v9s0 1.5-1.5 1.5h-12s-1.5 0-1.5-1.5V6s0-1.5 1.5-1.5m16.5 3h1.5l1.5-1.5a1.5 1.5 0 0 1 1.5 1.5V18a1.5 1.5 0 0 1-1.5 1.5l-1.5-1.5h-1.5m-10.5-1.5v3m-3 0h6m9-9h-1.5m1.5 3h-1.5"
    }, null, -1)
  ]));
}
const computerDeviceDesktop = { render };
export {
  computerDeviceDesktop as default,
  render
};
//# sourceMappingURL=computer-device-desktop.svg.js.map
